import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom'
import * as Screens from './screens';
import * as Components from './components';

function App() {
  
  return (
    <BrowserRouter>
    <>
      <Components.HeaderMenu/>
      <Switch>
        <Route exact path="/">
          <Screens.TrangChu/>
        </Route>
        <Route path="/v2/tin-tuc">
          <Screens.TinTuc/>
        </Route>
        <Route path="/v2/do-thi">
          <Screens.DoThi/>
        </Route>
        <Route path="/v2/danh-muc">
          <Screens.DanhMuc/>
        </Route>
        <Route path="/v2/bao-cao-phan-tich">
          <Screens.BCPT/>
        </Route>
        <Route path="/v2/bao-cao-tai-chinh">
          <Screens.BCTC/>
        </Route>
      </Switch>
    </>
   </BrowserRouter>
  )
}

export default App;
